import { render, staticRenderFns } from "./RolesNewRoleModal.vue?vue&type=template&id=cd37ce0e&scoped=true"
import script from "./RolesNewRoleModal.vue?vue&type=script&lang=js"
export * from "./RolesNewRoleModal.vue?vue&type=script&lang=js"
import style0 from "./RolesNewRoleModal.vue?vue&type=style&index=0&id=cd37ce0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd37ce0e",
  null
  
)

export default component.exports